import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "container"
};
var _hoisted_2 = {
  class: "columns"
};
var _hoisted_3 = {
  class: "column is-6"
};
var _hoisted_4 = {
  class: "content"
};
var _hoisted_5 = {
  class: "title"
};
var _hoisted_6 = {
  class: "column is-6"
};
var _hoisted_7 = {
  class: "content"
};
var _hoisted_8 = {
  class: "title"
};
var _hoisted_9 = {
  href: "https://bulma.io/",
  target: "_blank"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" bulma ");

var _hoisted_11 = {
  href: "http://vuejs.org/",
  target: "_blank"
};

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" vue.js ");

var _hoisted_13 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"content has-text-centered\"><p><a href=\"https://twitter.com/tiagojco\" target=\"_blank\"><span class=\"icon va-middle\"><i class=\"fab fa-twitter\"></i></span> @tiagojco </a></p><p><a href=\"https://github.com/tiagojco/tiagoj.co\" target=\"_blank\"><span class=\"icon va-middle\"><i class=\"fab fa-github\"></i></span> https://github.com/tiagojco </a></p></div>");

export function render(_ctx, _cache) {
  var _component_ImgIcon = _resolveComponent("ImgIcon");

  return _openBlock(), _createBlock("footer", {
    class: "footer",
    alt: _ctx.locale
  }, [_createVNode("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode("div", _hoisted_3, [_createVNode("div", _hoisted_4, [_createVNode("h5", _hoisted_5, _toDisplayString(_ctx.t("message.template.footer.left.title")), 1), _createVNode("p", null, _toDisplayString(_ctx.t("message.template.footer.left.subtext")), 1)])]), _createVNode("div", _hoisted_6, [_createVNode("div", _hoisted_7, [_createVNode("h5", _hoisted_8, _toDisplayString(_ctx.t("message.template.footer.right.title")), 1), _createVNode("p", null, [_createVNode("a", _hoisted_9, [_createVNode(_component_ImgIcon, {
    class: "va-middle",
    file: "bulma-32x32.png",
    alt: "Bulma: Free, open source, and modern CSS framework based on Flexbox"
  }), _hoisted_10])]), _createVNode("p", null, [_createVNode("a", _hoisted_11, [_createVNode(_component_ImgIcon, {
    class: "va-middle",
    file: "vue.js-32x32.png",
    alt: "Vue.js: The Progressive JavaScript Framework"
  }), _hoisted_12])])])])]), _hoisted_13, _hoisted_14])], 8, ["alt"]);
}